import * as Sentry from "@sentry/react";
import {createRoutesFromChildren, matchRoutes, useLocation, useNavigationType} from "react-router-dom";
import React from "react";

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN as string;
const ENVIRONMENT = import.meta.env.MODE;

export function initSentry() {
    if (ENVIRONMENT !== "production") return;

    const integrations = [
        Sentry.reactRouterV6BrowserTracingIntegration({
            useEffect: React.useEffect,
            useLocation,
            useNavigationType,
            createRoutesFromChildren,
            matchRoutes,
        }),
    ];
    integrations.push(
        Sentry.replayIntegration({
            blockAllMedia: true,
            maskAllText: false,
        }),
    );

    Sentry.init({
        dsn: SENTRY_DSN,
        environment: ENVIRONMENT,
        enabled: true,
        sendDefaultPii: true,
        integrations,
        tracesSampleRate: 0.5,
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
    });
}
